import React from 'react';
import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

/**
 * React functional component representing the healthcare details for the mod flex selection.
 * @returns {React.Component} The rendered healthcare details component.
 */
const HealthcareDetails = ({ data }) => (
    <div style={{ whiteSpace: 'pre-line' }}>
        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.majorHealthReimbursement, { majorHealthReimbursement: data.majorHealthReimbursement }) }</Text>

        {
            data.majorHealthCombinedMaximumSelected ?
                <Text small margin="5px 0px 0px 0px">
                    { i18n.t(tokens.labels.signup.majorHealthCombinedMaximum, { majorHealthCombinedMaximum: helpers.formatNumber(data.majorHealthCombinedMaximum) }) }
                </Text>
                :
                null
        }
        
        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.paramedicalReimbursement, { paramedicalReimbursement: data.paramedicalReimbursement }) }</Text>

        {
            (data.paramedicalCombinedMaximumSelected) ?
                <Text small margin="5px 0px 0px 0px">
                    { i18n.t(tokens.labels.signup.paramedicalCombinedMaximum, { paramedicalCombinedMaximum: helpers.formatNumber(data.paramedicalCombinedMaximum) }) }
                </Text>
                :
                (data.paramedicalPerPractitionerSelected ?
                    <React.Fragment>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.acupuncturistMaximum) } ${ i18n.t(tokens.labels.signup.acupuncturistMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.audiologistMaximum) } ${ i18n.t(tokens.labels.signup.audiologistMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.chiropractorMaximum) } ${ i18n.t(tokens.labels.signup.chiropractorMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.chiropodistMaximum) } ${ i18n.t(tokens.labels.signup.chiropodistMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.massageMaximum) } ${ i18n.t(tokens.labels.signup.massageMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.naturopathMaximum) } ${ i18n.t(tokens.labels.signup.naturopathMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.osteopathMaximum) } ${ i18n.t(tokens.labels.signup.osteopathMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.occupationalTherapistMaximum || 0) } ${ i18n.t(tokens.labels.signup.occupationalTherapistMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.physiotherapyMaximum) } ${ i18n.t(tokens.labels.signup.physiotherapyMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.podiatristMaximum) } ${ i18n.t(tokens.labels.signup.podiatristMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.psychologistMaximum) } ${ i18n.t(tokens.labels.signup.psychologistMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.registeredDieticianMaximum) } ${ i18n.t(tokens.labels.signup.registeredDieticianMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.socialWorkerMaximum) } ${ i18n.t(tokens.labels.signup.socialWorkerMaximum) }` }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { `$${ data.paramedicalApplyAmountToAllSelected ? helpers.formatNumber(data.paramedicalMaximum) : helpers.formatNumber(data.speechTherapyMaximum) } ${ i18n.t(tokens.labels.signup.speechTherapyMaximum) }` }
                        </Text>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.acupuncturistMaximum) } ${ i18n.t(tokens.labels.signup.acupuncturistMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.audiologistMaximum) } ${ i18n.t(tokens.labels.signup.audiologistMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.chiropractorMaximum) } ${ i18n.t(tokens.labels.signup.chiropractorMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.chiropodistMaximum) } ${ i18n.t(tokens.labels.signup.chiropodistMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.massageMaximum) } ${ i18n.t(tokens.labels.signup.massageMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.naturopathMaximum) } ${ i18n.t(tokens.labels.signup.naturopathMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.osteopathMaximum) } ${ i18n.t(tokens.labels.signup.osteopathMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.occupationalTherapistMaximum) } ${ i18n.t(tokens.labels.signup.occupationalTherapistMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.physiotherapyMaximum) } ${ i18n.t(tokens.labels.signup.physiotherapyMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.podiatristMaximum) } ${ i18n.t(tokens.labels.signup.podiatristMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.psychologistMaximum) } ${ i18n.t(tokens.labels.signup.psychologistMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.registeredDieticianMaximum) } ${ i18n.t(tokens.labels.signup.registeredDieticianMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.socialWorkerMaximum) } ${ i18n.t(tokens.labels.signup.socialWorkerMaximum) }` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.speechTherapyMaximum) } ${ i18n.t(tokens.labels.signup.speechTherapyMaximum) }` }</Text>
                    </React.Fragment>
                )
        }

        {
            (data.mentalWellnessMaximum > 0) ?
                <React.Fragment>
                    <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.mentalWellnessMaximum) } ${ i18n.t(tokens.labels.planDesign.mentalWellnessMaximum) }` }</Text>
                    <Text small margin="5px 0px 0px 0px">{ `${ data.mentalWellnessReimbursement }% ${ i18n.t(tokens.labels.planDesign.mentalWellnessReimbursement) }` }</Text>
                </React.Fragment>
                :
                null
        }
        {
            (data.functionalTreatmentMaximum > 0) ?
                <>
                    <Text medium margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.planDesign.functionalTreatmentMaximum) } ${ helpers.formatNumber(data.functionalTreatmentMaximum) }</Text>
                    <Text medium margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.planDesign.functionalTreatmentReimbursement)} { data.functionalTreatmentReimbursement }%</Text>
                </>
                :
                null
        }

        {
            data.cataractSurgeryEyewear !== 0 ?
                <Text small margin="5px 0px 0px 0px">
                    { i18n.t(tokens.labels.coverage.cataractSurgeryEyewear, { cataractSurgeryEyewear: helpers.formatNumber(data.cataractSurgeryEyewear), cataractSurgeryEyewearPeriod: data.cataractSurgeryEyewearPeriod })}
                </Text>
                : null
        }

        {
            data.includeConvalescentHospital > 0 ?
                <Text small margin="5px 0px 0px 0px">
                    { i18n.t(tokens.labels.coverage.convalescentHospital, { convalescentHospitalReimbursement: data.convalescentHospitalReimbursement, convalescentHospitalDailyMax: helpers.formatNumber(data.convalescentHospitalDailyMax), convalescentHospitalMaxDays: data.convalescentHospitalMaxDays })}
                </Text>
                : null
        }

        {
            data.artificialEyeLimb > 0 ? 
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.artificialEyeLimbPerLifetime) }</Text>
                :
                null
        }

        {
            data.apneaMachine > 0 ?
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.apneaMachineAmount, { apneaMachine: helpers.formatNumber(data.apneaMachine) })}</Text>
                :
                null
        }

        {
            data.insulinPump > 0 ?
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.insulinPumpAmount, { insulinPump: helpers.formatNumber(data.insulinPump) }) }</Text>
                :
                null
        }   

        {
            data.hearingAids > 0 ?
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.hearingAids, { hearingAids: helpers.formatNumber(data.hearingAids), hearingAidsPeriod: data.hearingAidsPeriod })}</Text>
                : null
        }

        {
            data.dentalAccidentMax > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.dentalAccidentMax) } ${ i18n.t(tokens.labels.signup.dentalAccidentMaximum) }` }
                </Text>
                : null
        }

        {
            data.cardiacRehabilitation > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.cardiacRehabilitation) } ${ i18n.t(tokens.labels.signup.cardiacRehabilitationMaximum) }` }</Text>
                :
                null
        }

        {
            data.footOrthotics > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.footOrthotics) } ${ i18n.t(tokens.labels.signup.footOrthoticsMaximum) }` }</Text>
                :
                null
        }

        {
            data.orthopedicShoes > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.orthopedicShoes) } ${ i18n.t(tokens.labels.signup.orthopedicShoesMaximum) }` }</Text>
                :
                null
        }

        {
            data.privateDutyNursing > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.privateDutyNursing) } ${ i18n.t(tokens.labels.signup.privateDutyNursingMaximum) }` }</Text>
                :
                null
        }

        {
            data.prosthetics > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.prosthetics) } ${ i18n.t(tokens.labels.signup.prostheticsLifetimeMaximum) }` }</Text>
                :
                null
        }

        {
            data.artificialEyeLimbRepairReplacement > 0 ? 
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.artificialEyeLimbRepairReplacement) } ${ i18n.t(tokens.labels.signup.artificialEyeLimbsRepairReplacementMaximum) }` }</Text>
                :
                null
        }

        {
            data.bloodPressureMonitor > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.bloodPressureMonitor) } ${ i18n.t(tokens.labels.signup.bloodPressureMonitorLifetimeMaximum) }` }</Text>
                :
                null
        }

        {
            data.compressionStockings > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.compressionStockings) } ${ i18n.t(tokens.labels.signup.compressionStockingsMaximum) }` }</Text>
                :
                null
        }

        {
            data.glucoseMonitoringEquipmentSupplies > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.glucoseMonitoringEquipmentSupplies) } ${ i18n.t(tokens.labels.signup.glucoseMonitoringEquipmentSuppliesMaximum) }` }</Text>
                :
                null
        }

        {
            data.insulinPumpSupplies > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.insulinPumpSupplies) } ${ i18n.t(tokens.labels.signup.insulinPumpSuppliesMaximum) }` }</Text>
                :
                null
        }

        {
            data.tensMachine > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.tensMachine) } ${ i18n.t(tokens.labels.signup.tensMachineLifetimeMaximum) }` }</Text>
                :
                null
        }

        {
            data.viscosupplementation > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.viscosupplementation) } ${ i18n.t(tokens.labels.signup.viscosupplementationMaximum) }` }</Text>
                :
                null
        }

        {
            data.wheelchairManual > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.wheelchairManual) } ${ i18n.t(tokens.labels.signup.wheelchairManualLifetimeMaximum) }` }</Text>
                :
                null
        }

        {
            data.wheelchairElectric > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.wheelchairElectric) } ${ i18n.t(tokens.labels.signup.wheelchairElectricLifetimeMaximum) }` }</Text>
                :
                null
        }

        {
            data.wigs > 0 ?
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.wigs) } ${ i18n.t(tokens.labels.signup.wigsLifetimeMaximum) }` }</Text>
                :
                null
        }

        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.reasonableAndCustomaryExpenses) }</Text> 
        
        <div style={{ paddingLeft: "15px" }}>
            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.dropdowns.benefits.ambulanceServices) }</Text>
            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.hospital) }</Text>
            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.dropdowns.benefits.medicalEquipment) }</Text>
            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.dropdowns.benefits.medicalServicesAndSupplies) }</Text>
            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.dropdowns.benefits.apneaMachineCPAP) }</Text>
            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.dropdowns.benefits.apneaMask) }</Text>
            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.dropdowns.benefits.bracesWithRigidSupports) }</Text>
            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.dropdowns.benefits.crutches) }</Text>
            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.dropdowns.benefits.ippBreathingMachine) }</Text>
            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.dropdowns.benefits.ostomySupplies) }</Text>
            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.dropdowns.benefits.surgicalBra) }</Text>
        </div>

        {
            data.includeEmployeeAssistance &&
            <React.Fragment>
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.employeeFamilyAssistanceProgram) }</Text>
                {
                    data.includeOutOfCountryMedicalReferral &&
                    <React.Fragment>
                        <Text small margin="5px 0px 0px 0px">
                            { i18n.t(tokens.labels.coverage.outOfCountryMedicalReferralMax, { outOfCountryMedicalReferralMax: helpers.formatNumber(data.outOfCountryMedicalReferralMax) }) }
                        </Text>
                        <Text small margin="5px 0px 0px 0px">
                            { i18n.t(tokens.labels.coverage.outOfCountryMedicalReferralPerYearReimbursement, { outOfCountryMedicalReferralPerYearReimbursement: data.outOfCountryMedicalReferralPerYearReimbursement }) }
                        </Text>
                    </React.Fragment>
                }

                {
                    data.includeMedicalSecondOpinion &&
                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.medicalSecondOpinionCoverage) }</Text>
                }

                {
                    data.includeEldercare &&
                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.eldercareCoverage) }</Text>
                }

                {
                    data.includeMentalHealthOnDemand ?
                        <Text small bold margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.mentalHealthOnDemandCoverage) }</Text>
                        :
                        null
                }
            </React.Fragment>
        }

        {
            data.includeEyeExams &&
                <React.Fragment>
                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.eyeExamReimbursement, { eyeExamReimbursement: data.eyeExamReimbursement }) }</Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.signup.eyeExamAdultMax, { eyeExamAdultMax: helpers.formatNumber(data.eyeExamAdultMax), eyeExamRolloverPeriodAdult: data.eyeExamRolloverPeriodAdult }) }
                    </Text>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.signup.eyeExamChildMax, { eyeExamChildMax: helpers.formatNumber(data.eyeExamChildMax), eyeExamRolloverPeriodChild: data.eyeExamRolloverPeriodChild }) }
                    </Text>
                </React.Fragment>
        }

        {
            data.includeEyeGlassesAndContacts &&
                <React.Fragment>
                    <Text small margin="5px 0px 0px 0px">
                        { i18n.t(tokens.labels.signup.eyeGlassesAndContactsReimbursement, { eyeGlassesAndContactsReimbursement: data.eyeGlassesAndContactsReimbursement }) }
                    </Text>
                    {
                        data.eyeGlassesAndContactsAdultMax > 0 ?
                            <Text small margin="5px 0px 0px 0px">
                                { i18n.t(
                                    tokens.labels.signup.eyeGlassesAndContactsAdultMax, 
                                    { eyeGlassesAndContactsAdultMax: helpers.formatNumber(data.eyeGlassesAndContactsAdultMax), eyeGlassesAndContactsPeriodAdult: data.eyeGlassesAndContactsPeriodAdult }
                                )
                                }
                            </Text>
                            : null
                    }
                    {
                        data.eyeGlassesAndContactsChildMax > 0 ?
                            <Text small margin="5px 0px 0px 0px">
                                { i18n.t(
                                    tokens.labels.signup.eyeGlassesAndContactsChildMax, 
                                    { eyeGlassesAndContactsChildMax: helpers.formatNumber(data.eyeGlassesAndContactsChildMax), eyeGlassesAndContactsPeriodChild: data.eyeGlassesAndContactsPeriodChild }
                                )
                                }
                            </Text>
                            : null
                    }
                </React.Fragment>
        }

        {
            data.includeRequiredSafetyEyeWear ?
                <React.Fragment>
                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.requiredSafetyEyeWearReimbursement, { requiredSafetyEyeWearReimbursement: data.requiredSafetyEyeWearReimbursement }) }</Text>
                    {
                        data.requiredSafetyEyeWearAdultMax > 0 ?
                            <Text small margin="5px 0px 0px 0px">
                                { i18n.t(tokens.labels.signup.requiredSafetyEyeWearAdultMax, { requiredSafetyEyeWearAdultMax: helpers.formatNumber(data.requiredSafetyEyeWearAdultMax), requiredSafetyEyeWearPeriodAdult: data.requiredSafetyEyeWearPeriodAdult }) }
                            </Text>
                            : null
                    }
                    {
                        data.requiredSafetyEyeWearAdultMax > 0 ?
                            <Text small margin="5px 0px 0px 0px">
                                { i18n.t(tokens.labels.signup.requiredSafetyEyeWearChildMax, { requiredSafetyEyeWearChildMax: helpers.formatNumber(data.requiredSafetyEyeWearChildMax), requiredSafetyEyeWearPeriodChild: data.requiredSafetyEyeWearPeriodChild })}
                            </Text>
                            : null
                    }
                </React.Fragment>
                :
                null
        }

        {
            data.outOfCountryMax &&
                <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(data.outOfCountryMax) } ${ i18n.t(tokens.labels.signup.outOfCountryProvinceMaximum) }` }</Text>
        }

        {
            data.outOfCountryPeriod30 &&
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.outOfCountryProvincePeriod30Days) }</Text>
        }

        {
            data.outOfCountryPeriod60 &&
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.outOfCountryProvincePeriod60Days) }</Text>
        }

        {
            data.outOfCountryPeriod90 &&
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.outOfCountryProvincePeriod90Days) }</Text>
        }

        {
            data.outOfCountryPeriod120 &&
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.outOfCountryProvincePeriod120Days) }</Text>
        }

        {
            data.outOfCountryPeriod180 &&
                <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.signup.outOfCountryProvincePeriod180Days) }</Text>
        }

        {
            data.hasDeductible &&
                <React.Fragment>
                    {
                        data.soloDeductibleAmount ?
                            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.deductibleForSoloCoverage, { soloDeductibleAmount: helpers.formatNumber(data.soloDeductibleAmount) }) }</Text>
                            : null
                    }
                    {
                        data.duoDeductibleAmount ?
                            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.deductibleForDuoCoverage, { duoDeductibleAmount: helpers.formatNumber(data.duoDeductibleAmount) }) }</Text>
                            : null
                    }
                    {
                        data.familyDeductibleAmount ?
                            <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.deductibleForFamilyCoverage, { familyDeductibleAmount: helpers.formatNumber(data.familyDeductibleAmount) }) }</Text>
                            : null
                    }
                </React.Fragment>
        }

        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.monthWaitingPeriod, { eligibilityPeriod: data.eligibilityPeriod }) }</Text>
        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.minimumHoursPerWeekRequired, { minHoursPerWeek: data.minHoursPerWeek })}</Text>
        <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtAge, { terminationAge: data.terminationAge }) }</Text>
    </div>
);

export default HealthcareDetails;